import { useCallback, useEffect, useState } from 'react'
import { useLinkage } from './useLinkage'

interface ConnectManualModalState {
  isOpen: boolean
  open: () => void
  close: () => void
}

export const useConnectManualModal = (): ConnectManualModalState => {
  const { connected, hasCheckedStatus } = useLinkage()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (connected) {
      setIsOpen(false)
    }
  }, [connected])

  // 初回の接続確認前は connected=false が「未接続」と確定していないため開かない。
  const open = useCallback(() => {
    if (hasCheckedStatus) {
      setIsOpen(true)
    }
  }, [hasCheckedStatus])
  const close = useCallback(() => setIsOpen(false), [])

  return { isOpen, open, close }
}
